/**
 * The subject a generated one starts with, under the International standard.
 *
 * Its own module, and a leaf: `workflow/index.ts` argues why this string is a constant rather than
 * a tenant setting, and `subject.ts` needs it without pulling that module's chunk into a browser
 * route. One definition, three importers, no copy.
 *
 * The trailing space is part of it: the filename follows immediately, and a prefix that had to be
 * joined with a separator at every call site is a prefix that ends up joined three different ways.
 */
export const INTERNATIONAL_SUBJECT_PREFIX = 'Complete with FlowZa Sign: '
